// Client-side demo data + audit engine for Dendros Pulse.
// No backend required — everything runs in the browser.
// Module-level state persists across route changes; a hard refresh resets to seed.

const NOW = Date.now();
const DAY_MS = 24 * 60 * 60 * 1000;

function _d(daysAgo) {
    return new Date(NOW - daysAgo * DAY_MS).toISOString();
}

function uid() {
    return Math.random().toString(36).slice(2, 11);
}

function nowIso() {
    return new Date().toISOString();
}

// ---------- Seed data ----------
const SEED_ACCOUNTS = [
    {
        id: "001A000001Mxqr5",
        name: "Vertex Industries",
        industry: "Manufacturing",
        employees: 4200,
        arr: "$12M",
        owner: "Sarah Chen",
        icp_required_roles: ["VP_SALES", "VP_MARKETING", "CRO"],
        auto_prune_enabled: false,
    },
    {
        id: "001A000002Hpkz3",
        name: "Quantum Logistics",
        industry: "Transportation",
        employees: 1850,
        arr: "$4.2M",
        owner: "Marcus Rivera",
        icp_required_roles: ["VP_SALES", "DIRECTOR_REVOPS", "CMO"],
        auto_prune_enabled: true,
    },
    {
        id: "001A000003Wtbf8",
        name: "Helios Biotech",
        industry: "Healthcare",
        employees: 720,
        arr: "$2.1M",
        owner: "Priya Patel",
        icp_required_roles: ["CRO", "VP_SALES"],
        auto_prune_enabled: false,
    },
    {
        id: "001A000004Drnc1",
        name: "Arboris Cloud",
        industry: "SaaS",
        employees: 950,
        arr: "$8.5M",
        owner: "Jordan Kim",
        icp_required_roles: ["VP_SALES", "VP_MARKETING", "CRO", "CMO"],
        auto_prune_enabled: false,
    },
];

const SEED_CONTACTS = [
    // Vertex Industries
    { id: "003V000001A", account_id: "001A000001Mxqr5", name: "Daniel Hwang", title: "VP of Sales", email: "d.hwang@vertex.com", linkedin_company: "Stripe", sf_account_name: "Vertex Industries", title_last_updated: _d(420), icp_role: "VP_SALES", avatar_seed: "DH", status: "Active" },
    { id: "003V000002A", account_id: "001A000001Mxqr5", name: "Rachel Okonkwo", title: "Director of Marketing", email: "r.okonkwo@vertex.com", linkedin_company: "Vertex Industries", sf_account_name: "Vertex Industries", title_last_updated: _d(15), icp_role: null, avatar_seed: "RO", status: "Active" },
    { id: "003V000003A", account_id: "001A000001Mxqr5", name: "Tomás Reyes", title: "Chief Revenue Officer", email: "t.reyes@vertex.com", linkedin_company: "Vertex Industries", sf_account_name: "Vertex Industries", title_last_updated: _d(80), icp_role: "CRO", avatar_seed: "TR", status: "Active" },
    { id: "003V000004A", account_id: "001A000001Mxqr5", name: "Lena Voss", title: "Sales Operations Manager", email: "l.voss@vertex.com", linkedin_company: "Salesforce", sf_account_name: "Vertex Industries", title_last_updated: _d(290), icp_role: null, avatar_seed: "LV", status: "Active" },
    { id: "003V000005A", account_id: "001A000001Mxqr5", name: "Kenji Watanabe", title: "VP of Marketing", email: "k.watanabe@vertex.com", linkedin_company: "Vertex Industries", sf_account_name: "Vertex Industries", title_last_updated: _d(540), icp_role: "VP_MARKETING", avatar_seed: "KW", status: "Active" },
    { id: "003V000006A", account_id: "001A000001Mxqr5", name: "Aisha Bello", title: "Account Executive", email: "a.bello@vertex.com", linkedin_company: "Vertex Industries", sf_account_name: "Vertex Industries", title_last_updated: _d(45), icp_role: null, avatar_seed: "AB", status: "Active" },
    // Quantum Logistics
    { id: "003Q000001A", account_id: "001A000002Hpkz3", name: "Brandon Wells", title: "VP of Sales", email: "b.wells@quantumlog.com", linkedin_company: "Flexport", sf_account_name: "Quantum Logistics", title_last_updated: _d(610), icp_role: "VP_SALES", avatar_seed: "BW", status: "Active" },
    { id: "003Q000002A", account_id: "001A000002Hpkz3", name: "Yuki Tanaka", title: "Chief Marketing Officer", email: "y.tanaka@quantumlog.com", linkedin_company: "Convoy", sf_account_name: "Quantum Logistics", title_last_updated: _d(380), icp_role: "CMO", avatar_seed: "YT", status: "Active" },
    { id: "003Q000003A", account_id: "001A000002Hpkz3", name: "Helena Krause", title: "Senior AE", email: "h.krause@quantumlog.com", linkedin_company: "Quantum Logistics", sf_account_name: "Quantum Logistics", title_last_updated: _d(8), icp_role: null, avatar_seed: "HK", status: "Active" },
    { id: "003Q000004A", account_id: "001A000002Hpkz3", name: "Idris Bashir", title: "Solutions Engineer", email: "i.bashir@quantumlog.com", linkedin_company: "Quantum Logistics", sf_account_name: "Quantum Logistics", title_last_updated: _d(120), icp_role: null, avatar_seed: "IB", status: "Active" },
    { id: "003Q000005A", account_id: "001A000002Hpkz3", name: "Camille Dubois", title: "Director of Operations", email: "c.dubois@quantumlog.com", linkedin_company: "Quantum Logistics", sf_account_name: "Quantum Logistics", title_last_updated: _d(20), icp_role: null, avatar_seed: "CD", status: "Active" },
    // Helios Biotech
    { id: "003H000001A", account_id: "001A000003Wtbf8", name: "Dr. Anika Shah", title: "Chief Revenue Officer", email: "a.shah@heliosbio.com", linkedin_company: "Helios Biotech", sf_account_name: "Helios Biotech", title_last_updated: _d(180), icp_role: "CRO", avatar_seed: "AS", status: "Active" },
    { id: "003H000002A", account_id: "001A000003Wtbf8", name: "Marcus Whitfield", title: "VP of Sales", email: "m.whitfield@heliosbio.com", linkedin_company: "Helios Biotech", sf_account_name: "Helios Biotech", title_last_updated: _d(95), icp_role: "VP_SALES", avatar_seed: "MW", status: "Active" },
    { id: "003H000003A", account_id: "001A000003Wtbf8", name: "Sofia Martínez", title: "Director of Clinical Affairs", email: "s.martinez@heliosbio.com", linkedin_company: "Helios Biotech", sf_account_name: "Helios Biotech", title_last_updated: _d(220), icp_role: null, avatar_seed: "SM", status: "Active" },
    { id: "003H000004A", account_id: "001A000003Wtbf8", name: "Gregor Nowak", title: "Senior Product Manager", email: "g.nowak@heliosbio.com", linkedin_company: "Moderna", sf_account_name: "Helios Biotech", title_last_updated: _d(310), icp_role: null, avatar_seed: "GN", status: "Active" },
    // Arboris Cloud
    { id: "003C000001A", account_id: "001A000004Drnc1", name: "Elena Vasquez", title: "VP of Sales", email: "e.vasquez@arboris.io", linkedin_company: "Arboris Cloud", sf_account_name: "Arboris Cloud", title_last_updated: _d(12), icp_role: "VP_SALES", avatar_seed: "EV", status: "Active" },
    { id: "003C000002A", account_id: "001A000004Drnc1", name: "Ravi Subramanian", title: "VP of Marketing", email: "r.subramanian@arboris.io", linkedin_company: "Datadog", sf_account_name: "Arboris Cloud", title_last_updated: _d(720), icp_role: "VP_MARKETING", avatar_seed: "RS", status: "Active" },
    { id: "003C000003A", account_id: "001A000004Drnc1", name: "Naomi Frank", title: "Customer Success Lead", email: "n.frank@arboris.io", linkedin_company: "Arboris Cloud", sf_account_name: "Arboris Cloud", title_last_updated: _d(33), icp_role: null, avatar_seed: "NF", status: "Active" },
    { id: "003C000004A", account_id: "001A000004Drnc1", name: "Theo Brennan", title: "Account Executive", email: "t.brennan@arboris.io", linkedin_company: "Arboris Cloud", sf_account_name: "Arboris Cloud", title_last_updated: _d(60), icp_role: null, avatar_seed: "TB", status: "Active" },
    { id: "003C000005A", account_id: "001A000004Drnc1", name: "Mira Achterberg", title: "Sales Development Rep", email: "m.achterberg@arboris.io", linkedin_company: "Snowflake", sf_account_name: "Arboris Cloud", title_last_updated: _d(450), icp_role: null, avatar_seed: "MA", status: "Active" },
];

const SEED_REPLACEMENTS = {
    "001A000001Mxqr5": [
        { name: "Olivia Bergstrom", title: "VP of Sales", email: "o.bergstrom@vertex.com", company: "Vertex Industries", icp_role: "VP_SALES", source: "dendros", confidence: 92, linkedin_url: "linkedin.com/in/olivia-bergstrom" },
    ],
    "001A000002Hpkz3": [
        { name: "Jonas Lindqvist", title: "VP of Sales", email: "j.lindqvist@quantumlog.com", company: "Quantum Logistics", icp_role: "VP_SALES", source: "dendros", confidence: 89, linkedin_url: "linkedin.com/in/jonas-lindqvist" },
        { name: "Priya Raghavan", title: "Chief Marketing Officer", email: "p.raghavan@quantumlog.com", company: "Quantum Logistics", icp_role: "CMO", source: "dendros", confidence: 87, linkedin_url: "linkedin.com/in/priya-raghavan" },
        { name: "Wren Castellanos", title: "Director of RevOps", email: "w.castellanos@quantumlog.com", company: "Quantum Logistics", icp_role: "DIRECTOR_REVOPS", source: "dendros", confidence: 81, linkedin_url: "linkedin.com/in/wren-castellanos" },
    ],
    "001A000003Wtbf8": [],
    "001A000004Drnc1": [
        { name: "Carmen Delacroix", title: "VP of Marketing", email: "c.delacroix@arboris.io", company: "Arboris Cloud", icp_role: "VP_MARKETING", source: "dendros", confidence: 94, linkedin_url: "linkedin.com/in/carmen-delacroix" },
        { name: "Hideo Yamashita", title: "Chief Revenue Officer", email: "h.yamashita@arboris.io", company: "Arboris Cloud", icp_role: "CRO", source: "dendros", confidence: 88, linkedin_url: "linkedin.com/in/hideo-yamashita" },
        { name: "Selene Brooks", title: "Chief Marketing Officer", email: "s.brooks@arboris.io", company: "Arboris Cloud", icp_role: "CMO", source: "dendros", confidence: 76, linkedin_url: "linkedin.com/in/selene-brooks" },
    ],
};

// ---------- Mutable in-memory store ----------
const store = {
    accounts: SEED_ACCOUNTS.map((a) => ({ ...a })),
    contacts: SEED_CONTACTS.map((c) => ({ ...c })),
    replacements: Object.entries(SEED_REPLACEMENTS).flatMap(([acc_id, list]) =>
        list.map((c) => ({ id: uid(), account_id: acc_id, ...c })),
    ),
    audit_logs: [],
    byok: [],
};

// ---------- Audit engine ----------
const STALE_THRESHOLD_DAYS = 365;

function isGhost(c) {
    return c.linkedin_company.trim().toLowerCase() !== c.sf_account_name.trim().toLowerCase();
}

function daysSince(iso) {
    return Math.floor((Date.now() - new Date(iso).getTime()) / DAY_MS);
}

function isStale(c) {
    return daysSince(c.title_last_updated) > STALE_THRESHOLD_DAYS;
}

function classify(c) {
    if (c.status === "Inactive") return ["INACTIVE", "Already removed"];
    if (isGhost(c)) return ["RED", `Employment signals show current employer is ${c.linkedin_company} — left ${c.sf_account_name}`];
    if (isStale(c)) {
        const d = daysSince(c.title_last_updated);
        return ["YELLOW", `Title unverified for ${d} days — likely outdated`];
    }
    return ["GREEN", "Verified active — current employer matches"];
}

function computeHealth(total, red, yellow, missingIcp) {
    if (total === 0) return 0;
    let base = 100;
    base -= Math.floor((red / total) * 60);
    base -= Math.floor((yellow / total) * 25);
    base -= missingIcp * 8;
    return Math.max(0, Math.min(100, base));
}

function logEvent(account_id, action, details = "", contact_id = null, contact_name = null) {
    const entry = {
        id: uid(),
        account_id,
        action,
        actor: "demo.rep@dendros.io",
        target_contact_id: contact_id,
        target_contact_name: contact_name,
        details,
        timestamp: nowIso(),
    };
    store.audit_logs.unshift(entry);
    return entry;
}

function delay(ms) {
    return new Promise((r) => setTimeout(r, ms));
}

// ---------- API surface ----------
export const dendrosApi = {
    listAccounts: async () => {
        await delay(60);
        return store.accounts.map((a) => ({ ...a }));
    },
    getAccount: async (id) => {
        await delay(80);
        const account = store.accounts.find((a) => a.id === id);
        if (!account) throw new Error("Account not found");
        const contacts = store.contacts.filter((c) => c.account_id === id).map((c) => ({ ...c }));
        return { account: { ...account }, contacts };
    },
    runAudit: async (id) => {
        await delay(900); // simulate scan
        const account = store.accounts.find((a) => a.id === id);
        if (!account) throw new Error("Account not found");
        const active = store.contacts.filter((c) => c.account_id === id && c.status === "Active");

        const ghosts = [];
        const stale = [];
        const healthy = [];
        const presentRoles = new Set();

        for (const c of active) {
            const [sev, reason] = classify(c);
            const finding = { contact: { ...c }, severity: sev === "INACTIVE" ? "GREEN" : sev, reason };
            if (sev === "RED") ghosts.push(finding);
            else if (sev === "YELLOW") stale.push(finding);
            else if (sev === "GREEN") {
                healthy.push(finding);
                if (c.icp_role) presentRoles.add(c.icp_role);
            }
        }

        const required = new Set(account.icp_required_roles || []);
        const missing_icp_roles = [...required].filter((r) => !presentRoles.has(r)).sort();
        const score = computeHealth(active.length, ghosts.length, stale.length, missing_icp_roles.length);

        logEvent(id, "SYNC_INITIATED", `Audit run — score ${score}, ghosts ${ghosts.length}, stale ${stale.length}`);
        for (const g of ghosts) {
            logEvent(id, "GHOST_DETECTED", g.reason, g.contact.id, g.contact.name);
        }

        return {
            account_id: id,
            account_name: account.name,
            health_score: score,
            total_contacts: active.length,
            ghosts,
            stale,
            healthy,
            missing_icp_roles,
            audited_at: nowIso(),
        };
    },
    prune: async (contact_id, reason) => {
        await delay(180);
        const c = store.contacts.find((x) => x.id === contact_id);
        if (!c) throw new Error("Contact not found");
        c.status = "Inactive";
        const entry = logEvent(c.account_id, "CONTACT_REMOVED", reason || "Removed via Dendros", c.id, c.name);
        return { success: true, contact_id, audit_entry: entry };
    },
    toggleAutoPrune: async (account_id, enabled) => {
        await delay(60);
        const a = store.accounts.find((x) => x.id === account_id);
        if (!a) throw new Error("Account not found");
        a.auto_prune_enabled = enabled;
        logEvent(account_id, "AUTO_REMOVE_TOGGLED", `Auto-remove ${enabled ? "enabled" : "disabled"}`);
        return { success: true, account_id, auto_prune_enabled: enabled };
    },
    findReplacements: async (id) => {
        await delay(220);
        const account = store.accounts.find((a) => a.id === id);
        if (!account) throw new Error("Account not found");
        const active = store.contacts.filter((c) => c.account_id === id && c.status === "Active");
        const presentRoles = new Set();
        for (const c of active) {
            const [sev] = classify(c);
            if (sev === "GREEN" && c.icp_role) presentRoles.add(c.icp_role);
        }
        const required = new Set(account.icp_required_roles || []);
        const missing = new Set([...required].filter((r) => !presentRoles.has(r)));
        const cands = store.replacements
            .filter((c) => c.account_id === id && missing.has(c.icp_role))
            .map((c) => ({ ...c }));
        logEvent(id, "HEAL_PIPELINE_QUERIED", `Found ${cands.length} candidates for missing roles ${[...missing].sort()}`);
        return cands;
    },
    inject: async (account_id, candidate_id) => {
        await delay(220);
        const idx = store.replacements.findIndex((c) => c.id === candidate_id && c.account_id === account_id);
        if (idx === -1) throw new Error("Candidate not found");
        const cand = store.replacements[idx];
        const newContact = {
            id: `003NEW${uid().toUpperCase()}`,
            account_id,
            name: cand.name,
            title: cand.title,
            email: cand.email,
            linkedin_company: cand.company,
            sf_account_name: cand.company,
            title_last_updated: nowIso(),
            status: "Active",
            avatar_seed: cand.name
                .split(" ")
                .slice(0, 2)
                .map((p) => p[0])
                .join("")
                .toUpperCase(),
            icp_role: cand.icp_role,
        };
        store.contacts.push(newContact);
        store.replacements.splice(idx, 1);
        logEvent(account_id, "CONTACT_INJECTED", `Injected ${cand.name} (${cand.title}) via ${cand.source}`, newContact.id, cand.name);
        return { success: true, contact: newContact };
    },
    auditLog: async (account_id) => {
        await delay(40);
        return store.audit_logs.filter((e) => e.account_id === account_id).slice(0, 50).map((e) => ({ ...e }));
    },
    saveByok: async (provider, api_key) => {
        await delay(80);
        const masked = api_key.length > 8 ? api_key.slice(0, 4) + "•".repeat(api_key.length - 8) + api_key.slice(-4) : "•".repeat(api_key.length);
        const existing = store.byok.find((b) => b.provider === provider);
        if (existing) {
            existing.key_masked = masked;
            existing.updated_at = nowIso();
        } else {
            store.byok.push({ provider, key_masked: masked, updated_at: nowIso() });
        }
        return { success: true, provider, key_masked: masked };
    },
    listByok: async () => {
        await delay(40);
        return store.byok.map((b) => ({ ...b }));
    },
};
